module.exports = __webpack_public_path__ + "img/线框.f6157c1f.png";